// Import React
import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ImageWithFallback extends Component {
    constructor(props) {
        super(props);
        this.state = {
            primaryImageError: false,
            secondaryImageError: false,
            tertiaryImageError: false,
        };
    }

    handlePrimaryImageError = () => {
        this.setState({ primaryImageError: true });
    };

    handleSecondaryImageError = () => {
        this.setState({ secondaryImageError: true });
    };

    handleTertiaryImageError = () => {
        this.setState({ tertiaryImageError: true });
    };

    render() {
        const { src, fallbackSrc, tertiarySrc, fallbackComponent, alt, className } = this.props;
        const { primaryImageError, secondaryImageError, tertiaryImageError } = this.state;

        if (primaryImageError && secondaryImageError && tertiaryImageError) {
            return fallbackComponent;
        }

        if (secondaryImageError) {
            return (
                <img
                    src={tertiarySrc}
                    alt={alt || 'Tertiary Image'}
                    className={className}
                    onError={this.handleTertiaryImageError}
                />
            );
        }

        if (primaryImageError) {
            return (
                <img
                    src={fallbackSrc}
                    alt={alt || 'Fallback Image'}
                    className={className}
                    onError={this.handleSecondaryImageError}
                />
            );
        }

        return (
            <img
                src={src}
                alt={alt || 'Image'}
                className={className}
                onError={this.handlePrimaryImageError}
            />
        );
    }
}

ImageWithFallback.propTypes = {
    src: PropTypes.string.isRequired,
    fallbackSrc: PropTypes.string.isRequired,
    tertiarySrc: PropTypes.string.isRequired,
    fallbackComponent: PropTypes.element.isRequired,
    alt: PropTypes.string,
    className: PropTypes.string,
};

ImageWithFallback.defaultProps = {
    alt: 'Default image',
    className: '',
};

export default ImageWithFallback;